import { render, staticRenderFns } from "./MecanicaView.vue?vue&type=template&id=bcd6ae0e&scoped=true&"
import script from "./MecanicaView.vue?vue&type=script&lang=js&"
export * from "./MecanicaView.vue?vue&type=script&lang=js&"
import style0 from "./MecanicaView.vue?vue&type=style&index=0&id=bcd6ae0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd6ae0e",
  null
  
)

export default component.exports